var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.2C0 12.4794 0 9.11905 1.30792 6.55211C2.4584 4.29417 4.29417 2.4584 6.55211 1.30792C9.11905 0 12.4794 0 19.2 0H22.8C29.5206 0 32.8809 0 35.4479 1.30792C37.7058 2.4584 39.5416 4.29417 40.6921 6.55211C42 9.11905 42 12.4794 42 19.2V22.8C42 29.5206 42 32.8809 40.6921 35.4479C39.5416 37.7058 37.7058 39.5416 35.4479 40.6921C32.8809 42 29.5206 42 22.8 42H19.2C12.4794 42 9.11905 42 6.55211 40.6921C4.29417 39.5416 2.4584 37.7058 1.30792 35.4479C0 32.8809 0 29.5206 0 22.8V19.2Z",
    fill: "#F8EFED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_54_23038",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_54_23038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 27.75C16.8375 27.75 16.4844 27.6031 16.1906 27.3094C15.8969 27.0156 15.75 26.6625 15.75 26.25V16.5H15V15H18.75V14.25H23.25V15H27V16.5H26.25V26.25C26.25 26.6625 26.1031 27.0156 25.8094 27.3094C25.5156 27.6031 25.1625 27.75 24.75 27.75H17.25ZM24.75 16.5H17.25V26.25H24.75V16.5ZM18.75 24.75H20.25V18H18.75V24.75ZM21.75 24.75H23.25V18H21.75V24.75Z",
    fill: "#FD7657"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconRed);
export default __webpack_public_path__ + "static/media/delete-icon-red.17062bc4c3daa93ac0c2bda441a30db8.svg";
export { ForwardRef as ReactComponent };